import "./CoverImageFrontpage.less";
import * as React from "react";

interface CoverImageFrontpageProps {
    imageUrl?: string
}

export class CoverImageFrontpage extends React.Component<CoverImageFrontpageProps, {}> {
    public render() {
        const styleObject = {}
        if(this.props.imageUrl != null){
            styleObject["backgroundImage"] = "url(" + this.props.imageUrl + ")";
        }
        return (
            <div className="cover-image-frontpage" style={styleObject}>
                <div className="highlight-component">
                    {this.props.children}
                </div>
            </div>
        )
    }
}